// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1oMOH","col":"styles_col__h1RBW"};